/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-component-lifecycle-hooks */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class Sidepeek extends Component {
  // drawer props
  isOpen = false;

  title = '';
  onClose = null;
  onSave = null;
  saveLabel = 'Save';
  isSaveDisabled = false;
  isLoading = false;

  // student list props
  students = null;

  selectedStudents = null;
  studentsWithReports = null;
  staleStudents = null;
  @tracked allSelected = false;
  @tracked selectedCount = 0;
  // Set when the caller could not resolve the group's roster, so "who already
  // has a report" is unknown. Replaces the student list with an error state
  // rather than letting the list render a guess.
  rosterUnavailable = false;
  emptyTitle = 'No students in this group';
  emptyMessage =
    'Students need to be added to this group before reports can be created.';

  // Optional standing explanation shown above the list — for context that
  // applies to the whole drawer rather than to one student (e.g. the drawer was
  // opened for a closed reporting period). Rendered only when notice is set.
  notice = null;
  noticeTitle = null;

  get someSelected() {
    return this.selectedCount > 0 && !this.allSelected;
  }

  onToggleAll = null;
  onToggleStudent = null;

  // Snapshot so contains re-evaluates when selectedStudents reference changes
  @tracked
  _selectedSnapshot = null;

  init() {
    super.init(...arguments);
    this._refreshSnapshot();
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);
    this._refreshSnapshot();
  }

  _refreshSnapshot() {
    this._selectedSnapshot = this.selectedStudents
      ? this.selectedStudents.slice()
      : [];
  }

  @action
  toggleStudent(student) {
    if (this.onToggleStudent) {
      this.onToggleStudent(student);
    }
  }

  @action
  toggleAll() {
    if (this.onToggleAll) {
      this.onToggleAll();
    }
  }
}
